/**
 * Clasifica el mensaje de error de la respuesta normalizada del servicio de facturación
 * y retorna un objeto estructurado para manejo diferenciado en la UI.
 *
 * - Errores de conexión/red: mensaje contiene "conexión"
 * - Errores de servidor (HTTP 500): mensaje contiene "servidor"
 * - Errores de validación (HTTP 422): mensaje parseable como JSON con errores por campo
 * - Errores generales: cualquier otro mensaje
 *
 * @param {string} mensaje - Mensaje de la respuesta normalizada
 * @returns {{ tipo: 'conexion'|'servidor'|'validacion'|'general', mensaje: string, erroresCampo: object }}
 */
export function clasificarErrorFacturacion(mensaje) {
  const resultado = {
    tipo: 'general',
    mensaje: 'Error al generar la factura. Por favor, intenta nuevamente.',
    erroresCampo: {}
  };

  if (!mensaje) {
    resultado.tipo = 'servidor';
    resultado.mensaje = 'Ocurrió un error en el servidor. Por favor, intenta nuevamente más tarde.';
    return resultado;
  }

  // Error de conexión / red
  if (mensaje.toLowerCase().includes('conexión')) {
    resultado.tipo = 'conexion';
    resultado.mensaje = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
    return resultado;
  }

  // Error de servidor (HTTP 500)
  if (mensaje.toLowerCase().includes('servidor')) {
    resultado.tipo = 'servidor';
    resultado.mensaje = 'Ocurrió un error en el servidor. Por favor, intenta nuevamente más tarde.';
    return resultado;
  }

  // Intentar parsear como errores de campo (HTTP 422)
  try {
    const parsed = JSON.parse(mensaje);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const keys = Object.keys(parsed);
      if (keys.length > 0 && keys.every(k => typeof parsed[k] === 'string')) {
        resultado.tipo = 'validacion';
        resultado.mensaje = '';
        resultado.erroresCampo = parsed;
        return resultado;
      }
    }
  } catch {
    // No es JSON — tratar como mensaje general o texto de validación
  }

  // Mensaje de texto plano (podría ser un error 422 no-JSON o cualquier otro)
  resultado.tipo = 'general';
  resultado.mensaje = mensaje;
  return resultado;
}
